import axios from "axios";

const clearCache = async (onFinished?: (cleared: boolean) => void): Promise<boolean> => {
    if (!process.env.NEXT_PUBLIC_CACHE_CLEAR_DEFAULT_ENDPOINT && process.env.NODE_ENV !== "test") {
        console.error("NEXT_PUBLIC_CACHE_CLEAR_DEFAULT_ENDPOINT not defined in .env.local");
        onFinished?.(false);
        return false;
    }

    if (process.env.NODE_ENV !== "production") {
        try {
            const response = await axios.get<{ cleared: boolean }>(
                `${process.env.NEXT_PUBLIC_CACHE_CLEAR_DEFAULT_ENDPOINT}`
            );

            const {
                data: { cleared },
            } = response;

            if (cleared) console.info("Cache cleared");

            onFinished?.(cleared);

            return cleared ?? false;
        } catch (error) {
            console.error("Cache failed to clear:", error);
            onFinished?.(false);
            return false;
        }
    }
    console.error("Cannot use 'clearCache()' in production!");
    onFinished?.(false);
    return false;
};

export default clearCache;
